import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import { Button, Icon, TextField } from "@rentiohq/web-shared/dist/components";
import React from "react";
import * as S from "./ApplicationToolbar.styled";

interface IProps {
  searchQuery: string;
  onSearchChange: (query: string) => void;
  groupActionNode?: React.ReactNode;
  filterNode?: React.ReactNode;
  autoWaitlistNode?: React.ReactNode;
  calendarNode?: React.ReactNode;
}

export const ApplicationToolbar = (props: IProps) => {
  const {
    searchQuery,
    onSearchChange,
    groupActionNode,
    filterNode,
    autoWaitlistNode,
    calendarNode,
  } = props;

  return (
    <S.ToolbarContainer>
      {groupActionNode}

      <div style={{ flex: 1 }}>
        <TextField
          name="application-search"
          placeholder={getLocalizedText("system.search") + "..."}
          label={getLocalizedText("system.search")}
          labelHidden
          value={searchQuery}
          onChange={(e: any) => onSearchChange(e.target.value)}
          prefix={<Icon source="search" />}
          floatIcon={searchQuery ? <Icon source="removeCircle" /> : undefined}
          floatIconClick={() => onSearchChange("")}
          autoComplete="off"
        />
      </div>

      <S.ToolbarFilterWrap>
        {filterNode ?? (
          <Button appearance="ghost" iconBeforeName="view">
            {getLocalizedText("system.filters")}
          </Button>
        )}
      </S.ToolbarFilterWrap>

      {autoWaitlistNode}
      {autoWaitlistNode && calendarNode && <S.ToolbarDivider />}
      {calendarNode}
    </S.ToolbarContainer>
  );
};
